import { useEffect, useState, useRef } from 'react';
import { Routes, Route, useLocation, Switch } from "react-router-dom";
import { useQuery } from "react-query";
import i18n from "i18next";

import './main/App.css';
import { AppContext } from "./Context";
import Home from "./main/pages/Home";
import Product from "./main/pages/Product";
import ProductPop from "./main/pages/Productpop";
import Content from "./main/pages/Content";
import Reset from "./main/pages/Reset";
import Cats from "./main/pages/Cats";
import Search from "./main/pages/Search";

import Account from "./main/pages/account";
import History from "./main/pages/history";
import HistoryInfo from "./main/pages/historyInfo";

import Login from "./main/pages/Login";
import Reg from "./main/pages/reg";
import NoUser from "./main/pages/noUser";
import Thanks from "./main/pages/Thanks";
import CartInfo from "./main/pages/CartInfo";
import Cart from "./main/pages/Cart";
import Success from "./main/pages/popups/Success";

import { Get, Loader } from './main/inc/Fetch'

function App() {

    const [siteInfo, setsiteInfo] = useState({});
    const [userinfo, setuserinfo] = useState({});
    const [cart, setcart] = useState([]);
    const [site_menu, setsite_menu] = useState([]);
    const [success, setsuccess] = useState(false);
    const [cats, setcats] = useState([]);
    const [referrer, setreferrer] = useState([]);

    const contextVars = {
        siteData:[siteInfo, setsiteInfo], 
        user:[userinfo, setuserinfo], 
        cartData:[cart, setcart], 
        successData:[success, setsuccess], 
        siteMenu:[site_menu, setsite_menu], 
        siteCats:[cats, setcats], 
        Referrer:[referrer, setreferrer], 
    }

    
    async function loadData() {
        let res = await Get('home');
        
        return res;
    }
    
    const { data, error, isLoading } = useQuery("home", loadData); 
    
    
    const location = useLocation();
    let previousLocation = location.state?.previousLocation;
    if (!previousLocation) {
        previousLocation = location
    }

    
    useEffect(() => {
        
        if (cart?.length) {
            let cartInfo = JSON.stringify(cart); 
            localStorage.setItem("cart", cartInfo);
        }
        
    }, [cart]);

    useEffect(() => {
        
        let cartData = localStorage.getItem("cart");
        setcart(JSON.parse(cartData));

        if (!i18n.language) {
            i18n.language = "he";
        }
        // language
        document.documentElement.lang = i18n.language;
        if (i18n.language == "he" || i18n.language == "ar") {
            document.documentElement.dir = "rtl"
        }

        import(`./main/locales/${i18n.language}/style.css`);

    }, []);


    useEffect(() => {
        setreferrer(d => [...d, location.pathname]);

    }, [location?.pathname]);

    useEffect(() => {

        if (data?.company?._id) {
            setsiteInfo(data?.company);

            if (data?.company?.website?.theme?.colors) {
                Object.keys(data?.company?.website?.theme?.colors)?.map(k => {
                    let val = data?.company?.website?.theme?.colors[k];
                    document.documentElement.style.setProperty(k, val);
                });
            }
            
            global.currency = data?.company?.settings?.currency?.val;
        }
   
        setuserinfo(data?.userinfo);
        setsite_menu(data?.menu);
 
        setcats(data?.cats);
        
    }, [data]);

    if (!siteInfo?.settings) {
        return <Loader />;
    }
    
    return (
        <AppContext.Provider value={contextVars}>

            {success && <Success data={success}/>}
            {isLoading ? <Loader /> :
                <>
                    <div id='mainBodyData' className='mainBodyData'>
                        <Routes location={previousLocation}>
                            <Route path="/" element={<Home data={data} />} />
                            <Route path="/product/:id" element={<Product />} />
                            <Route path="/content/:id" element={<Content />} />
                            <Route path="/content/:id/:sub" element={<Content />} />
                            <Route path="/cat" element={<Cats sortBy={siteInfo?.settings?.sort}/>} />
                            <Route path="/cat/:id" element={<Cats sortBy={siteInfo?.settings?.sort}/>} />
                            <Route path="/reset/:id" element={<Reset />} />
                            <Route path="/Search" element={<Search />} />

                            {userinfo?._id ?  
                            <>
                                <Route path="/account" element={<Account />} />
                                <Route path="/history" element={<History />} />
                            </>
                            : false}
                            <Route path="*" element={<Home data={data} />} />
                            

                        </Routes>   
                    </div>

                    {/* {previousLocation &&  */}
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/reg" element={<Reg />} />
                            <Route path="/noUser" element={<NoUser />} />
                            <Route path="/cart" element={<Cart />} /> 
                            <Route path="/cartInfo" element={<CartInfo />} /> 
                            <Route path="/thanks" element={<Thanks />} />
                            
                            <Route path="/productPop/:id" element={<ProductPop />} />

                            {userinfo?._id ?  
                            <>
                                <Route path="/historyInfo/:id" element={<HistoryInfo />} />
                            </>
                            :false}

                        </Routes>
                    {/* } */}
                    
                </>
            }
            

        </AppContext.Provider>
        
    );
}

export default App;
